import LocalStorageStore from 'ember-simple-auth/session-stores/local-storage';

export default class ApplicationSessionStore extends LocalStorageStore {}
